import React from 'react'
import html from '../assets/experience/html.png';
import css from '../assets/experience/css.png';
import javascript from '../assets/experience/javascript.png';
import react from '../assets/experience/react.png';
import next from '../assets/experience/nextjs.png';
import graphql from '../assets/experience/graphql.png';
import github from '../assets/experience/github.png';
import tailwind from '../assets/experience/tailwind.png';

const Experience = () => {
    const techs = [
        {
            id : 1,
            src : html,
            title: 'html',
            style : 'shadow-blue-500'
        },
        {
            id : 2,
            src : css,
            title: 'css',
            style : 'shadow-blue-500'
        },
        {
            id : 3,
            src : javascript,
            title: 'javascript',
            style : 'shadow-yellow-500'
        },
        {
            id : 4,
            src : react,
            title: 'react',
            style : 'shadow-blue-600'
        },
        {
            id : 5,
            src : tailwind,
            title: 'tailwind',
            style : 'shadow-sky-400'
        },
        {
            id : 6,
            src : next,
            title: 'Next js',
            style : 'shadow-white'
        },
        {
            id : 7,
            src : graphql,
            title: 'GraphQl',
            style : 'shadow-pink-400'
        },
        {
            id : 8,
            src : github,
            title: 'GitHub',
            style : 'shadow-gray-400'
        },
    ]
  return (
    <div name="experience" className='bg-gradient-to-b from-gray-800 to-black w-full h-screen'>
        <div className='max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white'>
            <div>
                <p className='text-4xl font-bold border-b-4 border-gray-500 p-2 inline my-3'>Experience</p>
                <p className='py-6'>These are the technologies i've worked</p>
            </div>
            <div className='w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0'>

                {
                    techs.map(({id,src,title,style})=>(
                        <div key={id} className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style} `}>
                        <img src={src} alt="" className='w-20 mx-auto'/>
                        <p className='mt-4'>{title}</p>
                    </div>
                    ))
                }
       
            </div>
        </div>

    </div>
  )
}
export default Experience
